const uiTranslations = {
  cookie_consent: {
    message:
      "We use cookies to ensure you get the best experience on our website.",
    learn_more: "Learn more",
    accept: "Accept",
    decline: "Decline",
  },
}

export default uiTranslations
